import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import ProductCard from "../../components/ProuctCard";
import { useDispatch, useSelector } from "react-redux";
import { BLACK, PRIMARY } from "../../styles/color";
import offerImage from "../../Images/%off.png";
import { toast } from "react-toastify";
import {
  useGetAPIWithoutTokenQuery,
  usePostAddToCartWithTokenMutation,
  useRemoveFromCartWithTokenMutation,
} from "../../Api/api";
import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
} from "../../Api/apiConstant";
import {
  addToCart,
  removeFromCart,
  removeItemFromCart,
} from "../../Features/services/cartSlice";
import debounce from "lodash.debounce";
import { Box } from "@mui/material";
import { useThemeColors } from "../../Context/Theme";
import { getLoggedIn, getToken, getUserId } from "../../LoginModule/LoginUtility";

const PopularProducts = ({ eventName }) => {
  const navigate = useNavigate();
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();

  const [selectedSku, setSelectedSku] = useState({});
  const [selectedSkuQuantity, setSelctedSkuQuantity] = useState([])
  const [blankQuantitySku, setBlankQuantitySku] = useState([])
  const cartId = sessionStorage.getItem("cartId");
  const eventId = sessionStorage.getItem("event_id");

  const [AddToCart] = usePostAddToCartWithTokenMutation();
  const [Removecart] = useRemoveFromCartWithTokenMutation();
  const [RemoveFromCart] = useRemoveFromCartWithTokenMutation();

  const userId = getUserId()
  const token = getToken()

  const dispatch = useDispatch();
  const { data, isLoading, isSuccess, isError, error } =
    useGetAPIWithoutTokenQuery(
      `/api/product/readAllProducts?event_id=${eventId}&page=1&limit=100000`, { refetchOnMountOrArgChange: true, skip: !eventId }
    );
  const cartItem = useSelector((state) => state?.cart?.items);
  const isLoggedIn = getLoggedIn();

  const productsToShow = data?.data
    ?.filter((product) => product?.skus?.some((sku) => sku?.sku_status === 1))
    .slice(0, 10);

  const handleSeeAll = () => {
    navigate(`/events/${eventName}/shop`, { state: { category: "all" } });
  };

  const handleUnitSelect = (product, skuId) => {
    try {
      const selectedSku = product?.skus.find((sku) => sku?.sku_id === skuId);
      if (selectedSku) {
        setSelectedSku((prevSelectedSku) => ({
          ...prevSelectedSku,
          [product.product_id]: selectedSku,
        }));
      }
    } catch (error) {

    }
  };

  const handleChangeQuantity = async (value, product) => {
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];
    if (value === "") {
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
      setBlankQuantitySku(prev => [...prev, selectedSkuData.sku_id])
      debouncedRemoveFromCart(product, 0)
      return;
    }
    if(value === 0){
      debouncedRemoveFromCart(product, 0)
    }
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    // Create the new cart item with the desired structure
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))
    setSelctedSkuQuantity(prev => {
      // Remove any previous entries with the same skuId
      const filtered = prev.filter(item => item.skuId !== selectedSkuData.sku_id);
      // Add the new one at the end
      return [...filtered, { skuId: selectedSkuData.sku_id, quantity: value }];
    });
    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: value,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
      total_price: (
        (selectedSkuData?.discount_price || selectedSkuData?.regular_price) *
        (selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1)
      ).toFixed(2),
      user_id: userId,
      event_id: eventId,
      status: "active",
      created_date: null,
      product_details: {
        product_id: product.product_id,
        product_name: product.product_name,
        product_description: product.product_description,
        state_tax: product.state_tax || "0.00",
        city_tax: product.city_tax || "0.00",
        brands: product.brands || [],
        categories: product.categories || [],
        productImg: product.productImg || [],
        skus: [selectedSkuData],
        categoryTax: product.categoryTax || [],
      },
    };
    const existingCartItem = cartItem.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      // Update quantity and total price for an existing item
      newCartItem.quantity = value;
      newCartItem.total_price = (newCartItem.quantity * parseFloat(newCartItem.price)).toFixed(2);
    }

    // Redirect to login if the user is not logged in
    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    try {
      // Dispatch the new cart item to Redux store
      // dispatch(
      //   addToCart({
      //     ...newCartItem,
      //   })
      // );
      // Make API call to add the item to the backend cart
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [
            {
              product_id: newCartItem.product_id,
              sku_id: newCartItem.sku_id,
              quantity: newCartItem.quantity,
              price: newCartItem.price,
              total_price: newCartItem.total_price,
            },
          ],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data?.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  }

  const handleAddToCart = async (product) => {
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      }
      else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];
    setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))

    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
      total_price: (
        (selectedSkuData?.discount_price || selectedSkuData?.regular_price) *
        (selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1)
      ).toFixed(2),
      user_id: userId,
      event_id: eventId,
      status: "active",
      created_date: null,
      product_details: {
        product_id: product.product_id,
        product_name: product.product_name,
        product_description: product.product_description,
        state_tax: product.state_tax || "0.00",
        city_tax: product.city_tax || "0.00",
        brands: product.brands || [],
        categories: product.categories || [],
        productImg: product.productImg || [],
        skus: [selectedSkuData],
        categoryTax: product.categoryTax || [],
      },
    };

    const existingCartItem = cartItem.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      newCartItem.quantity = existingCartItem.quantity + 1;
      newCartItem.total_price = (
        newCartItem.quantity * parseFloat(newCartItem.price)
      ).toFixed(2);
    }

    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    try {
      // dispatch(addToCart({ ...newCartItem }));
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [
            {
              product_id: newCartItem.product_id,
              sku_id: newCartItem.sku_id,
              quantity: newCartItem.quantity,
              price: newCartItem.price,
              total_price: newCartItem.total_price,
            },
          ],
          event_id: eventId,
        },
        token,
      });
      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };

  const handleRemoveFromCart = async (product, value) => {
    const isSelectedSkuEmpty =
      !selectedSku || Object.keys(selectedSku).length === 0;

    const selectedSkuId = isSelectedSkuEmpty
      ? product?.skus?.filter(i => i.sku_status === 1)?.[0]?.sku_id
      : selectedSku[product?.product_id]?.sku_id;

    if (value !== 0) {
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuId))
      setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuId))
    }

    const selectedProduct = isSelectedSkuEmpty
      ? { ...product, skus: [product?.skus[0]?.skus?.filter(i => i.sku_status === 1)?.[0]] }
      : { ...product, skus: [selectedSku[product?.product_id]] };

    const existingCartItem = cartItem?.find((item) => {
      return (
        item.product_id === selectedProduct?.product_id &&
        item.sku_id === selectedSkuId
      );
    });

    if (!existingCartItem) {
      console.warn("Product not found in cart.");
      return;
    }
    const newQuantity = value === 0 ? value : existingCartItem.quantity - 1
    const newCartItem = {
      product_id: existingCartItem.product_id,
      sku_id: existingCartItem.sku_id,
      quantity: newQuantity,
      bundle_id: existingCartItem.bundle_id,
      price:
        existingCartItem?.product_details?.skus[0]?.discount_price ||
        existingCartItem?.product_details?.skus[0]?.regular_price,
    };

    try {
      if (newQuantity > 0) {
        dispatch(removeFromCart({ ...product, quantity: newQuantity }));
        await Removecart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [newCartItem],
            event_id: eventId,
            callFrom: 'Remove'
          },
          token,
        });
      } else {
        dispatch(removeItemFromCart({ itemId: existingCartItem?.product_id }));
        await RemoveFromCart({
          url: REMOVE_FROM_CART,
          formData: {
            cart_id: cartId,
            product_id: existingCartItem.product_id,
            sku_id: existingCartItem.sku_id,
            event_id: eventId,
          },
          token,
        });
      }
    } catch (error) {

    }
  };

  const debouncedAddToCart = debounce(handleAddToCart, 300);
  const debouncedRemoveFromCart = debounce(handleRemoveFromCart, 300);
  if (productsToShow?.length <= 0) {
    return
  }
  if (productsToShow?.every(product =>
    product?.skus?.every(sku => sku?.sku_status === 0)
  )) {
    return;
  }

  return (
    <div
      className="event-container fo_css_event_popular_product_container"
      style={{
        margin: "20px auto",
        maxWidth: "91.6%",
        borderRadius: "25px",

      }}
    >
      <div className="d-flex justify-content-between align-items-center w-100">
        <p
          style={{
            fontSize: fontSizeHeading || "30px",
            fontWeight: fontWeightHeading || "700",
            color: textColor || BLACK,
            fontFamily: fontFamilyHeading
          }}
        >
          Popular Products
        </p>
        <p
          onClick={handleSeeAll}
          style={{
            fontSize: fontSizeHeading || "20px",
            fontWeight: fontWeightHeading || "400",
            color: primaryColor || PRIMARY,
            cursor: "pointer",
            fontFamily: fontFamilyHeading
          }}
        >
          See all
        </p>
      </div>

      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"
        gap="16px"
        style={{ placeItems: "center" }}
        className="fo_css_event_popular_product_content"
      >
        {productsToShow?.map((product, index) => (
          <ProductCard
            offer={product?.offer}
            ageRestriction={product?.categories[0]?.age_validation === "21"}
            productName={product?.product_name}
            productType={product?.categories[0]?.category_name}
            categoryId={product?.categories[0]?.category_id}
            sku={product?.skus}
            price={
              selectedSku[product.product_id]?.regular_price ||
              product?.skus[0]?.regular_price
            }
            discount={
              selectedSku[product.product_id]?.discount_price ||
              product?.skus[0]?.discount_price
            }
            offerDiscount={
              selectedSku[product.product_id]?.discount_amount ||
              product?.skus[0]?.discount_amount
            }
            product={product}
            productId={product?.product_id}
            image={product?.productImg?.[0]?.product_img}
            rating={product?.rating || 4}
            buttonText="ADD"
            onClick={() => debouncedAddToCart(product)}
            offerImage={offerImage}
            addQuantity={() => debouncedAddToCart(product)}
            removeQuantity={() => debouncedRemoveFromCart(product)}
            onUnitSelect={(prod, skuID, selectedSkus) =>
              handleUnitSelect(prod, skuID)
            }
            handleChangeQuantity={handleChangeQuantity}
            blankQuantitySku={blankQuantitySku}
            selectedSkuQuantity={selectedSkuQuantity}
          />
        ))}
      </Box>
    </div>
  );
};

export default PopularProducts;
